<app-dialog [(isOpen)]="isOpen" data-test-id="contract-dialog">
  <h1 class="contract-dialog-header" data-test-id="contract-dialog-title">
    {{ 'tenantConfiguration.contracts.addContract' | translate }}
  </h1>
  <div data-test-id="contract-dialog-content">
    <app-contract-form [isReadMode]="false" [(contract)]="contract" />
  </div>
  <div class="contract-dialog-footer" data-test-id="contract-dialog-footer">
    <app-button
      type="secondary"
      (click)="onNoClick()"
      data-test-id="contract-dialog-cancel-button"
      >{{ 'tenantConfiguration.contracts.cancel' | translate }}</app-button
    >
    <app-button
      type="primary"
      (click)="onSave()"
      data-test-id="contract-dialog-save-button"
      >{{ 'tenantConfiguration.contracts.save' | translate }}</app-button
    >
  </div>
</app-dialog>
